const callReasons = [
  { label: "Llamada de presentación", value: "Llamada de presentación" },
  { label: "Fecha de actualización de avance, observaciones", value: "Fecha de actualización de avance, observaciones" },
  { label: "Recocrdatorio de reunión", value: "Recordatorio de reunión" },
  { label: "Seguimiento de campañas", value: "Seguimiento de campañas" },
  { label: "Recordatorio de pago", value: "Recordatorio de pago" },
  { label: "Soporte operativo", value: "Soporte operativo" },
  { label: "Renegociación precio", value: "Renegociación precio" },
  { label: "Cobranza", value: "Cobranza" },
  { label: "Checklist", value: "Checklist" },
  { label: "Visitas programadas", value: "Visitas programadas" },
  { label: "Recomendación", value: "Recomendación" },
  { label: "Recotizacion", value: "Recotizacion" },
  { label: "Baja del servicio", value: "Baja del servicio" },
  { label: "Venta de nuevo servicio", value: "Venta de nuevo servicio" },
  { label: "Soporte administrativo", value: "Soporte administrativo" },
]

export default callReasons;